import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

const ParentalIcons = ({ enabled, theme = {} }) => (
  <div>
    {enabled ? (
      <Icon icon="checkmark-thin" color="white" size="large" />
    ) : (
      <Icon theme={theme} icon="blocked" size="large" />
    )}
  </div>
);

export default ParentalIcons;

ParentalIcons.propTypes = {
  enabled: PropTypes.bool.isRequired,
  theme: PropTypes.shape({}),
};
